import React, { useState } from "react";
import styles from "./PaymentsModal.module.scss";
import ExitIcon from "../../../../assets/icons/ExitIcon";
import CustomButton from "../../../CustomButton/CustomButton";
import Input from "../../../Input/Input";

const PaymentsModal = ({ setModal }) => {
  const [selectedOption, setSelectedOption] = useState("monthly");
  const [promoSection, setPromoSection] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const packages = [
    {
      title: "Пробный",
      price: "Бесплатно",
      period: "14 дней",
      description: "Для тех, кто хочет оценить богатство функционалаі",
      information: ["Ограниченный доступ"],
    },
    {
      title: "Базовый",
      price: selectedOption === "yearly" ? 60 * 12 * 0.8 : 60,
      period: selectedOption === "monthly" ? "Месяц" : "Год",
      description: "Для тех, кто хочет автоматизировать общение с клиентами",
      information: [
        "1500 бесплатных сообщений, сгенерированных ИИ / Месяц",
        "3.33 ₽ за дополнительное сообщение, сгенерированное ИИ",
      ],
    },
    {
      title: "Индивидуальный",
      price: "Обговаривается",
      period: selectedOption === "monthly" ? "Месяц" : "Год",
      description:
        "Для предприятий, которые хотят автоматизировать коммуникации, снизить затраты на поддержку и увеличить продажи.",
      information: [
        "24/7 поддержка",
        "Неограниченное дообучение",
        "Личный менеджер",
        "Стоимость сообщения от 1 ₽",
        "От 6000 сообщений/месяц",
      ],
    },
  ];

  return (
    <div className={styles.paymentModal}>
      <div className={styles.modalContent}>
        <div className={styles.contentHeader}>
          <h1 className={styles.headerTitle}>Выберите тариф</h1>
          <ExitIcon onClick={() => setModal(false)} />
        </div>
        <div className={styles.paymentOptionsContainer}>
          <div className={styles.paymentOptions}>
            <div className={styles.paymentOptions}>
              <button
                className={`${styles.option} ${
                  selectedOption === "monthly" ? styles.border : ""
                }`}
                onClick={() => setSelectedOption("monthly")}
              >
                Ежемесячная оплата
              </button>
              <button
                className={`${styles.option} ${
                  selectedOption === "yearly" ? styles.border : ""
                }`}
                onClick={() => setSelectedOption("yearly")}
              >
                Ежегодная (Экономия 20%)
              </button>
            </div>
          </div>
          <div className={styles.promoSection}>
            {promoSection && (
              <Input type="text" placeholder={"Введите промокод"} />
            )}

            <CustomButton
              blue
              width="200px"
              onClick={() => setPromoSection(!promoSection)}
            >
              {promoSection ? "Отмена" : "Использовать промокод"}
            </CustomButton>
          </div>
        </div>
        <div className={styles.packagesContainer}>
          {packages.map((packageItem, index) => (
            <div
              key={index}
              className={`${styles.package} ${
                selectedPlan === index ? styles.selected : ""
              }`}
              onClick={() => setSelectedPlan(index)}
            >
              <h2 className={styles.packageTitle}>{packageItem.title}</h2>
              <p className={styles.packagePrice}>
                <span className={styles.packagePriceSpan}>
                  {packageItem.price}{" "}
                  {typeof packageItem.price === "number" ? "USD" : ""}
                </span>
                / {packageItem.period}
              </p>
              <p className={styles.packageDescription}>
                {packageItem.description}
              </p>
              <span className={styles.line}></span>
              <ul className={styles.packageInformation}>
                {packageItem.information.map((info, i) => (
                  <li key={i}>{info}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className={styles.modalFooter}>
          <CustomButton>Оплатить подписку</CustomButton>
          <CustomButton blue>Отправить заявку</CustomButton>
        </div>
      </div>
    </div>
  );
};

export default PaymentsModal;
